import React from "react";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";

import Grid from "@mui/material/Grid";
import { useMediaQuery, useTheme } from "@mui/material";

import { ConfigurationStore, FilterStore } from "stores";

import {
  Filter,
  Schnellsuche,
  Fahrzeuge,
  Modell,
  Modelle,
  ModellGruppe,
  Indicator,
} from "./containers";

import { Sorter } from "./containers/components";

import { Detail, Archive } from "pages";
import Box from "@mui/material/Box";
const Catalog = (): JSX.Element => {
  const configuration = React.useContext(ConfigurationStore);
  const List = configuration.application?.groupedList ? Modelle : Fahrzeuge;

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<List />} />
        </Route>
        <Route path="/" element={<Layout disableMake />}>
          <Route path="/mo/:modell_id" element={<Modell />} />
          <Route path="/mg/:modell_gruppe_id" element={<ModellGruppe />} />
        </Route>
        <Route path="/dt/:id" element={<Detail />} />
        <Route path="/ar/:id" element={<Archive />} />
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </>
  );
};

interface iLayout {
  disableMake?: boolean;
}

const Layout: React.FC<iLayout> = ({ disableMake = false }): JSX.Element => {
  const theme = useTheme();
  // Gibt true zurück, wenn der Bildschirm breiter als 'sm' (600px) ist
  const isPhone = useMediaQuery(theme.breakpoints.down("md"));
  const {
    state: { order },
    dispatch,
  } = React.useContext(FilterStore);

  const changeSorter = (newSorter: string) => {
    dispatch({
      type: "CHANGE_ORDER",
      payload: newSorter,
    });
  };
  return (
    <>
      <Grid container>
        <Box sx={{ display: { xs: "none", md: "contents" } }}>
          <Grid size={{ xs: 3 }}>
            <Filter disableMake={disableMake} />
          </Grid>
        </Box>
        <Box sx={{ display: { xs: "contents", md: "none" } }}>
          {isPhone && <Schnellsuche />}
        </Box>
        <Grid size={{ xs: 12, md: 9 }}>
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              justifyContent: "space-between",
              position: "sticky",
              mb: 1,
              p: 1,
              top: -1,
              backgroundColor: "#FFFFFFEE",
              zIndex: 1,
              minHeight: 50,
            }}
          >
            <Box>
              <Indicator />
            </Box>
            <Sorter value={order} changeValueHandler={changeSorter} />
          </Box>
          <Outlet />
        </Grid>
      </Grid>
    </>
  );
};

export default Catalog;
